import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Terminal } from "lucide-react";
import api from "@/lib/api";
import { CATEGORY_STYLES } from "@/components/Badges";

export default function Categories() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  const categories = Object.keys(CATEGORY_STYLES);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-mono text-3xl font-extrabold mb-2">Categories</h1>
      <p className="font-mono text-sm text-slate-500 mb-8">// pick a domain to drill into</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {categories.map((cat, i) => {
          const s = CATEGORY_STYLES[cat];
          return (
            <Link
              key={cat}
              to={`/database?category=${encodeURIComponent(cat)}`}
              data-testid={`categories-card-${s.label.toLowerCase()}`}
              className="glass card-hover rounded-lg border border-slate-800 p-6 fade-up"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div className="w-12 h-12 rounded-md flex items-center justify-center mb-4"
                style={{ background: `${s.color}15`, border: `1px solid ${s.ring}` }}>
                <Terminal size={22} style={{ color: s.color }} />
              </div>
              <h2 className="font-mono text-xl font-bold" style={{ color: s.color }}>{s.label}</h2>
              <p className="text-sm text-slate-400 mt-2">{cat}</p>
              <div className="font-mono text-sm text-slate-500 mt-4">
                {stats?.by_category?.[cat] ?? "—"} entries →
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
